import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { CoercableComponent } from "features/feature";
import { Resource } from "features/resources/resource";
import Decimal from "util/bignum";
import { computeOptionalComponent } from "util/vue";
import { computed, Ref, StyleValue, toRefs } from "vue";
import ResourceVue from "features/resources/Resource.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    resource: null,
    color: null,
    classes: null,
    style: null,
    effectDisplay: null
  },
  setup(__props: any) {

const _props = __props as {
    resource: Resource;
    color?: string;
    classes?: Record<string, boolean>;
    style?: StyleValue;
    effectDisplay?: CoercableComponent;
}


const props = toRefs(_props);

const effectComponent = computeOptionalComponent(
    props.effectDisplay as Ref<CoercableComponent | undefined>
);

const showPrefix = computed(() => {
    return Decimal.lt(props.resource.value, "1e1000");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(showPrefix))
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "You have "))
      : _createCommentVNode("", true),
    _createVNode(ResourceVue, {
      resource: __props.resource,
      color: __props.color || 'white'
    }, null, 8, ["resource", "color"]),
    _createTextVNode(" " + _toDisplayString(__props.resource.displayName), 1),
    (_unref(effectComponent))
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _hoisted_3,
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(effectComponent))))
        ]))
      : _createCommentVNode("", true),
    _hoisted_4,
    _hoisted_5
  ]))
}
}

})